import { render } from "./체질량_결과.vue?vue&type=template&id=048c2a83"
import script from "./체질량_결과.vue?vue&type=script&lang=js"
export * from "./체질량_결과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__